import { render, staticRenderFns } from "./ScopesSelect.vue?vue&type=template&id=4ed22ad0&"
import script from "./ScopesSelect.vue?vue&type=script&lang=js&"
export * from "./ScopesSelect.vue?vue&type=script&lang=js&"
import style0 from "./ScopesSelect.vue?vue&type=style&index=0&id=4ed22ad0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports